import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { Frame as h } from "../Frame/Frame.js";
function l({
  alt: o = "",
  dark: s,
  light: e,
  ...m
}) {
  const c = h.useFrame(!0), t = (c == null ? void 0 : c.colorScheme) ?? "light dark";
  return t === "light dark" ? (
    // if the theme supports both light & dark color schemes,
    // we can rely on `prefers-color-scheme` media queries
    // which depends on the browser's color scheme preference
    /* @__PURE__ */ i("picture", { children: [
      /* @__PURE__ */ r("source", { media: "(prefers-color-scheme: dark)", srcSet: s }),
      /* @__PURE__ */ r("source", { media: "(prefers-color-scheme: light)", srcSet: e }),
      /* @__PURE__ */ r("img", { ...m, alt: o, src: e })
    ] })
  ) : (
    // for single color scheme themes (either light or dark),
    // we ignore the browser's color scheme preference, since
    // it could be set to a given color scheme while the dialog
    // theme only supports the other one
    /* @__PURE__ */ r("img", { ...m, alt: o, src: t === "light" ? e : s })
  );
}
export {
  l as LightDarkImage
};
//# sourceMappingURL=LightDarkImage.js.map
